import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { FormBuilder } from "@angular/forms";
import {
  NgModule,
  ApplicationRef
} from '@angular/core';
import {
  removeNgStyles,
  createNewHosts,
  createInputTransfer
} from '@angularclass/hmr';
import {
  RouterModule,
  PreloadAllModules
} from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IdlePreloadModule } from "@angularclass/idle-preload";
import { AuthHttp, AuthConfig } from 'angular2-jwt';
import { Http, RequestOptions } from '@angular/http';

import { BusyModule, BusyConfig } from 'angular2-busy';
import { NgZorroAntdModule } from 'ng-zorro-antd';

import { AppConfig } from './app.config';
import { HttpService } from '../providers/http.service';
import { StorageService } from '../providers/storage.service';
import { AuthService } from '../providers/auth.service';
import { AlertService } from '../providers/alert.service';
import { SignalrService } from "../providers/signalr.service";
import { RechargeService } from "../services/recharge.service";
// import { LotteryService } from "../providers/lottery.service";
import { AuthGuard } from '../providers/auth-guard.service';

import { ENV_PROVIDERS } from './environment';
import { routing } from './app.routes';
import { AppComponent } from './app.component';
import { APP_RESOLVER_PROVIDERS } from './app.resolver';
import { AppState, InternalStateType } from './app.service';
import { PagesModule } from './pages/pages.module';
import { NoContentComponent } from './no-content';
import { CurrLotteryModel } from '../models/betting.model';
import { MissionService } from '../providers/mission.services';
import { IndexDBService } from "./../providers/indexdb.service";
import { ReconnectionService } from "./../services/reconnection.service";
// import { SubDigetPipe } from "./../pipes/subString.pipe";
// import { CookieService } from 'ngx-cookie';

import '../styles/styles.scss';
import { MyObserverService } from './../services/myobject.service';

// Application wide providers
const APP_PROVIDERS = [
  ...APP_RESOLVER_PROVIDERS,
  AppState
];

type StoreType = {
  state: InternalStateType,
  restoreInputValues: () => void,
  disposeOldHosts: () => void
};

export function authHttpServiceFactory(http: Http, options: RequestOptions) {
  return new AuthHttp(new AuthConfig({ noJwtError: true, globalHeaders: [{ 'Content-Type': 'application/json' }] }), http, options);
}

@NgModule({
  bootstrap: [AppComponent],
  declarations: [
    AppComponent,
    NoContentComponent,


  ],
  /**
   * Import Angular's modules.
   */
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpModule,
    IdlePreloadModule.forRoot(),
    NgZorroAntdModule.forRoot(),
    PagesModule,
    routing

  ],
  /**
   * Expose our Services and Providers into Angular's dependency injection.
   */
  providers: [
    ENV_PROVIDERS,
    APP_PROVIDERS,
    AppConfig,
    SignalrService,
    MissionService,
    FormBuilder,
    CurrLotteryModel,
    HttpService,
    IndexDBService,
    // CookieService ,
    StorageService,
    RechargeService,
    // LotteryService,
    AlertService,
    AuthGuard,
    ReconnectionService,
    MyObserverService,
    {
      provide: AuthHttp,
      useFactory: authHttpServiceFactory,
      deps: [Http, RequestOptions]
    },
  ],
})
export class AppModule {

  constructor(
    public appRef: ApplicationRef,
    public appState: AppState
  ) { }

  public hmrOnInit(store: StoreType) {
    if (!store || !store.state) {
      return;
    }
    console.log('HMR store', JSON.stringify(store, null, 2));
    /**
     * Set state
     */
    this.appState._state = store.state;
    /**
     * Set input values
     */
    if ('restoreInputValues' in store) {
      let restoreInputValues = store.restoreInputValues;
      setTimeout(restoreInputValues);
    }

    this.appRef.tick();
    delete store.state;
    delete store.restoreInputValues;
  }

  public hmrOnDestroy(store: StoreType) {
    const cmpLocation = this.appRef.components.map((cmp) => cmp.location.nativeElement);
    /**
     * Save state
     */
    const state = this.appState._state;
    store.state = state;
    /**
     * Recreate root elements
     */
    store.disposeOldHosts = createNewHosts(cmpLocation);
    /**
     * Save input values
     */
    store.restoreInputValues = createInputTransfer();
    /**
     * Remove styles
     */
    removeNgStyles();
  }

  public hmrAfterDestroy(store: StoreType) {
    /**
     * Display new elements
     */
    store.disposeOldHosts();
    delete store.disposeOldHosts;
  }

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/app/app.module.ts